import type { TFunction } from "i18next";
import type { BookingScheduleInterface } from "../../Booking-Form/typings/booking.types";
import type { Dashboard2BookingParticipantTag } from "../types/dashboard2-work-status.types";
import {
  resolveScheduleDisplayParticipantTags,
  resolveScheduleDisplayTypeLabelWithTranslator
} from "./dashboard2-booking-type-label.utils";

export type PrimaryCharacteristicBadge = {
  id: "primary";
  typeLabel?: string;
  participantTags?: readonly Dashboard2BookingParticipantTag[];
};

/** Type + visitor/external chips for today's status — sourced from the primary schedule only. */
export function derivePrimaryCharacteristicBadge(
  primarySchedule: BookingScheduleInterface,
  t: TFunction
): PrimaryCharacteristicBadge | null {
  const typeLabel = resolveScheduleDisplayTypeLabelWithTranslator(primarySchedule, t);
  const participantTags = resolveScheduleDisplayParticipantTags(primarySchedule, typeLabel);

  if (!typeLabel.trim() && participantTags.length === 0) {
    return null;
  }

  return {
    id: "primary",
    typeLabel: typeLabel.trim() || undefined,
    participantTags: participantTags.length > 0 ? participantTags : undefined
  };
}
